import React, { useState, useEffect } from 'react';

const NetworkDetector: React.FC = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
    };

    const handleOffline = () => {
      setIsOnline(false);
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  if (isOnline) {
    return null; // Ne rien afficher si l'utilisateur est en ligne
  }

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-red-600 text-white p-4 z-50 text-center shadow-lg">
      <div className="container mx-auto flex items-center justify-center">
        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
        </svg>
        <span className="font-bold">Vous êtes hors ligne.</span>
        <span className="ml-2">LiveMatch nécessite une connexion Internet pour fonctionner correctement.</span>
      </div>
    </div>
  );
};

export default NetworkDetector;
